/**
 * Начертание, размер и стиль для шрифта
 *
 * v-f-[weight|size|style]=[value]
 */

import { getFirstLetterInUppercase, getPxOrValue } from 'lib/utils/string';

const getFontHandler = (attribute) => (el, { arg, value }) => {
  let val;
  const argOrValue = arg || value;

  if (attribute === 'size') {
    val = getPxOrValue(String(+argOrValue === argOrValue ? +argOrValue : argOrValue));
  } else if (attribute === 'weight') {
    val = String(+argOrValue === argOrValue ? +argOrValue : argOrValue);
  }

  el.style[`font${getFirstLetterInUppercase(attribute)}`] = val;
};

export default (Vue) => {
  ['weight', 'size', 'style'].forEach((item) => {
    Vue.directive(`f-${item}`, {
      bind: getFontHandler(item),
      update: getFontHandler(item),
    });
  });
};
